import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  root: {
    maxWidth: custom.form.maxWidth,
    marginBottom: 12,
  },
  rootSectionWidth: {
    maxWidth: 730,
  },
  message: {
    border: `2px solid ${palette.common.white}`,
  },
  messageRounded: {
    borderRadius: 12,
  },
}));
